<atn-ds-table [config]="editingVariablesFeature" />
